import React, { Component } from 'react';
import { Label } from 'reactstrap';
import { connect } from 'react-redux';
import * as sideBarActions from '../../../redux/sideBarActions';
import * as fabricCanvasActions from '../../../redux/fabricCanvasActions';
import { bindActionCreators } from 'redux';
import '../SideBarContainer.scss';
import { string } from '../../../localization';
import * as Constants from '../../../utilities/constants/Constants';
import DropboxChooser from 'react-dropbox-chooser';
import './UploadTemplate.scss';
import combinedStore from '../../../CombinedStore';
import UploadMoreTemplate from './UploadMoreTemplate';

const APP_KEY = 'lrega750w9xyfv5';

window._instagramCallbackResponse = () => {
  combinedStore.dispatch(sideBarActions.addInstagramContents());
};

class UploadTemplate extends Component {
  state = {
    isActiveAdd: false,
    moreUploadArray: [],
    shouldShowDropboxTheme: false,
    shouldShowInstagramTheme: false
  };

  componentDidMount = () => {
    this.shouldShowDropboxAndInstagram();
  };

  handleDropbox = files => {
    const { dispatchers } = this.props;
    dispatchers.sideBarActions.showDropboxUploadDialog(true);
    dispatchers.sideBarActions.saveDropBoxFile(files);
  };

  handleUploadLogo = (e, value) => {
    const { dispatchers } = this.props;
    e.target.value = null;
    dispatchers.sideBarActions.setIsUploadLogo(value);
  };

  openMenu = (header, uploadArray) => {
    this.setState({
      isActiveAdd: true,
      moreUploadArray: uploadArray
    });
  };

  closeMenu = () => {
    this.setState({
      isActiveAdd: false
    });
  };

  shouldShowDropboxAndInstagram = () => {
    const { themesArray, storeDetails } = this.props;

    const { scenesData, elementsData, photosData } = themesArray;
    let isDropboxHidden = true;
    let isInstagramHidden = true;

    const dataArray = Array.prototype.concat(
      scenesData,
      elementsData,
      photosData
    );

    for (let i = 0; i < dataArray.length; i++) {
      if (/_dropbox/.test(dataArray[i].internalName)) {
        isDropboxHidden = false;
        break;
      }
    }

    for (let i = 0; i < dataArray.length; i++) {
      if (/_instagram/.test(dataArray[i].internalName)) {
        isInstagramHidden = false;
        break;
      }
    }

    const dropbox =
      !isDropboxHidden &&
      storeDetails.supportsDropbox &&
      storeDetails.supportsUserPhotoUpload;

    const instagram = !isInstagramHidden && storeDetails.supportsInstagram;

    this.setState({
      shouldShowDropboxTheme: dropbox,
      shouldShowInstagramTheme: instagram
    });
  };

  getTagForUploadedContent = content => {
    if (content.imageSource == Constants.LOCAL_IMAGE_SOURCE) {
      if (content.userPhotoType == Constants.USER_PHOTO_ELEMENT_TYPE) {
        if (content.isPhoto) {
          return Constants.PHOTO_UPLOAD_KEY;
        }
        return Constants.OBJECT_UPLOAD_KEY;
      }
      if (content.userPhotoType == Constants.USER_PHOTO_SCENE_TYPE) {
        return Constants.BACKGROUND_UPLOAD_KEY;
      }
    } else if (content.imageSource == Constants.DROPBOX_IMAGE_SOURCE) {
      return Constants.DROPBOX_KEY;
    } else if (content.imageSource == Constants.INSTAGRAM_IMAGE_SOURCE) {
      return Constants.INSTAGRAM_KEY;
    }

    return '';
  };

  render() {
    const {
      uploadInfo,
      instagramData,
      storeDetails,
      dispatchers,
      envData
    } = this.props;
    const {
      header,
      moreUploadArray,
      isActiveAdd,
      shouldShowDropboxTheme,
      shouldShowInstagramTheme
    } = this.state;

    const uploadList = uploadInfo.uploadArray;
    const tags = [];
    for (let i = 0; i < uploadList.length; i++) {
      const tagKey = this.getTagForUploadedContent(uploadList[i]);
      if (tagKey) {
        tags.push(string[tagKey]);
      }
    }

    let dropBoxSliceIndex;
    if (uploadInfo.uploadArray.length == Constants.DISPLAY_IMAGES_COUNT) {
      dropBoxSliceIndex = Constants.DISPLAY_IMAGES_COUNT;
    } else if (uploadInfo.uploadArray.length > Constants.DISPLAY_IMAGES_COUNT) {
      dropBoxSliceIndex = Constants.DISPLAY_IMAGES_COUNT - 1;
    }

    let instagramSliceIndex;
    if (instagramData.length == Constants.DISPLAY_IMAGES_COUNT) {
      instagramSliceIndex = Constants.DISPLAY_IMAGES_COUNT;
    } else if (instagramData.length > Constants.DISPLAY_IMAGES_COUNT) {
      instagramSliceIndex = Constants.DISPLAY_IMAGES_COUNT - 1;
    }

    return (
      <div className={!isActiveAdd ? 'wrapper' : 'wrapper active'}>
        <div className='main'>
          <>
            <div id='upload-pane' className='theme-wrapper-upload'>
              <div>
                {storeDetails.supportsInstagram ||
                storeDetails.supportsDropbox ||
                storeDetails.supportsUserPhotoUpload ? (
                  <Label className='upload-image-label'>
                    {string.UPLOAD_IMAGE_KEY}
                  </Label>
                ) : null}
                {/* ChooseFromComputer */}
                {storeDetails.supportsUserPhotoUpload ? (
                  <label htmlFor='upload' className='upload-file '>
                    {' '}
                    {string.CHOOSE_FROM_COMPUTER_KEY}
                    <input
                      id='upload'
                      type='file'
                      onChange={dispatchers.sideBarActions.handleFileChange}
                      onClick={e => this.handleUploadLogo(e, false)}
                    />
                  </label>
                ) : null}

                {/* UploadLogo for giftwraps */}
                {envData.category === Constants.GIFTWRAPS_CATEGORY &&
                storeDetails.supportsUserPhotoUpload ? (
                  <label
                    htmlFor='uploadLogo'
                    className='upload-logo d-flex align-items-center justify-content-center '
                  >
                    <div className='upload-icon' />
                    {string.UPLOAD_LOGO_KEY}
                    <input
                      id='uploadLogo'
                      type='file'
                      onChange={dispatchers.sideBarActions.handleFileChange}
                      onClick={e => this.handleUploadLogo(e, true)}
                    />
                  </label>
                ) : null}
              </div>

              {/* Dropbox and instagram */}
              <div
                className='d-flex justify-content-between'
                id='upload-container'
              >
                {shouldShowDropboxTheme ? (
                  <div style={{ width: '48%' }}>
                    <DropboxChooser
                      appKey={APP_KEY}
                      linkType='direct'
                      success={files => this.handleDropbox(files)}
                      cancel={() => {}}
                      multiselect
                      extensions={[]}
                      id='chooser-drop'
                    >
                      <div className='theme-list-box-upload'>
                        <div
                          className='theme-list-box-container dropbox-icon'
                          key='Dropbox'
                        />
                        <span className='theme-list-box-label'>
                          {string.DROPBOX_KEY}
                        </span>
                      </div>
                    </DropboxChooser>
                  </div>
                ) : null}

                {shouldShowInstagramTheme ? (
                  <div style={{ width: '48%' }}>
                    <div className='theme-list-box-upload'>
                      <button
                        type='button'
                        style={{
                          border: 'none',
                          outline: 'none'
                        }}
                        aria-label='instagram'
                        className='theme-list-box-container instagram-icon'
                        key='Instagram'
                        onClick={
                          dispatchers.sideBarActions.instagramUploadIsClicked
                        }
                      />
                      <span className='theme-list-box-label'>
                        {string.INSTAGRAM_KEY}
                      </span>
                    </div>
                  </div>
                ) : null}
              </div>
              {/* UploadCollectionView */}
              <div style={{ marginTop: '12px', position: 'relative' }}>
                {uploadInfo.uploadArray.length > 0 ? (
                  <hr style={{ marginBottom: '5px' }} />
                ) : null}

                {uploadInfo.uploadArray
                  .slice(0, dropBoxSliceIndex)
                  .map((item, index) => (
                    <div>
                      <button
                        type='button'
                        className='folder-list-element-upload'
                        key={item.id}
                        style={{
                          backgroundImage: `url(${item.thumbnailPath})`,
                          width: '59px',
                          height: '59px'
                        }}
                        onClick={() => {
                          dispatchers.fabricCanvasActions.cloneForUploadContents(
                            item
                          );
                        }}
                      >
                        <text className='folder-label-tag'>
                          {` ${tags[index]} `}
                        </text>
                      </button>
                    </div>
                  ))}
                {uploadInfo.uploadArray.length >
                Constants.DISPLAY_IMAGES_COUNT ? (
                  <button
                    type='button'
                    style={{ background: 'none', outline: 'none' }}
                    className='folder-list-element-upload'
                    onClick={() => this.openMenu('', uploadInfo.uploadArray)}
                  >
                    <img
                      alt='right-arrow'
                      src='data:image/png;base64,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'
                    />
                  </button>
                ) : null}
              </div>
              {instagramData.length > 0 ? (
                <hr style={{ marginBottom: '10px' }} />
              ) : null}
              {instagramData.length > 0 ? (
                <div className='instagram-container'>
                  <div>
                    <text style={{ float: 'left' }}>
                      {string.INSTAGRAM_KEY}
                    </text>
                  </div>
                  <div>
                    {instagramData.slice(0, instagramSliceIndex).map(item => (
                      <button
                        type='button'
                        aria-label='upload'
                        className='folder-list-element-upload'
                        key={item.mediaId}
                        style={{
                          backgroundImage: `url(${item.thumbnailPath})`,
                          width: '59px',
                          height: '59px'
                        }}
                        onClick={() => {
                          dispatchers.fabricCanvasActions.cloneForUploadContents(
                            item
                          );
                        }}
                      />
                    ))}
                    {instagramData.length > Constants.DISPLAY_IMAGES_COUNT ? (
                      <button
                        type='button'
                        className='right-arrow'
                        onClick={() =>
                          this.openMenu(string.INSTAGRAM_KEY, instagramData)
                        }
                      >
                        <img
                          alt='right-arrow'
                          src='data:image/png;base64,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'
                        />
                      </button>
                    ) : null}
                  </div>
                </div>
              ) : null}

              {storeDetails.supportsInstagram ||
              storeDetails.supportsDropbox ||
              storeDetails.supportsUserPhotoUpload ? (
                <div style={{ marginTop: '12px' }}>
                  <hr />
                </div>
              ) : null}
            </div>
          </>
        </div>
        <>
          <div className='main-sub d-flex flex-column h-100 text-left'>
            <UploadMoreTemplate
              header={header}
              mappingArray={moreUploadArray}
              closeDrawer={this.closeMenu}
              tags={tags}
              onclick={dispatchers.fabricCanvasActions.cloneForUploadContents}
            />
          </div>
        </>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    activeTab: state.sideBar.activeSideBarTab,
    language: state.home.language,
    uploadInfo: state.sideBar.uploadInfo,
    storeDetails: state.modal.storeData,
    envData: state.modal.envData,
    instagramData: state.sideBar.instagramData,
    isDropboxHidden: state.modal.isDropboxHidden,
    isInstagramHidden: state.modal.isInstagramHidden,
    themesArray: state.modal.themesArray
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      sideBarActions: bindActionCreators(sideBarActions, dispatch),
      fabricCanvasActions: bindActionCreators(fabricCanvasActions, dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UploadTemplate);
